import { Fragment, useState } from "react";
import TransactionCard from "../cards/finances/TransactionCard";
import TransactionDetailsModal from "../popup/finances/TransactionDetailsModal";
import { useTransactions } from "../../../hooks/finances/useTransactions";
import { LATEST_TRANSACTION_PARAMS } from "../popup/finances/utils/transactionHelpers";
import GhostTransactionsCarousel from "../loading/skeletons/GhostTransactionCarousel";
import BaseCarousel from "./common/BaseCarousel";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../utils/schemas/language/pages/personalFinancesSchema";

function TransactionCarousel() {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const { latestTransactions, isLoading } = useTransactions(
    LATEST_TRANSACTION_PARAMS,
  );

  return (
    <Fragment>
      <BaseCarousel
        title={content.overview.latest_transactions.title}
        seeAllPath="/finances/personal-finances/transactions"
        seeAllText={content.global.see_all}
        items={latestTransactions}
        isLoading={isLoading}
        emptyMsg={content.overview.latest_transactions.empty}
        previousAlt={content.global.previous}
        nextAlt={content.global.next}
        /* Pass the specific ghost as a parameter */
        GhostComponent={
          <GhostTransactionsCarousel count={3} showPagination={false} />
        }
        /* Define how to render each card */
        renderItem={(item, index) => (
          <TransactionCard
            key={item.uuid || index}
            transaction={item}
            onClick={() => setSelectedTransaction(item)}
          />
        )}
      />

      {selectedTransaction && (
        <TransactionDetailsModal
          transaction={selectedTransaction}
          copy={content.transactions.details}
          commonCopy={content.global}
          onClose={() => setSelectedTransaction(null)}
        />
      )}
    </Fragment>
  );
}

export default TransactionCarousel;
